import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";

// Paleta de colores Colbún
const azul = "#007ad9";
const verde = "#99c800";
const gris = "#505259";
const naranja = "#E09B2D";
const amarillo = "#F2CB27";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentWrap = styled.div`
  flex: 1;
  margin-top: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ContenedorTabla = styled.div`
  padding: 5px;
  border-radius: 5px;
  border: solid 1px;
  border-color: ${gris};
  margin-top: 20px;
  width: 100%;
  max-width: 100%;
`;

export const Title = styled.div`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 10px;
  align-self: flex-start;
  color: ${gris};
`;

export const Div = styled.div`
  margin-bottom: 5%;
  width: 100%;
`;

export const StyledLink = styled(Link)`
  color: ${azul};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const EstadoCell = styled.td`
  background-color: ${({ estado }) => {
    switch (estado) {
      case "Pendiente":
        return "${amarillo}";
      case "Revisado":
        return "${verde}";
      default:
        return "#fff";
    }
  }};
`;

export const Button = styled.button`
  background-color: ${(props) => (props.disabled ? "#cccccc" : verde)};
  color: white;
  padding: 10px 20px;
  margin-left: 20px;
  border: none;
  border-radius: 5px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 16px;

  &:hover {
    background-color: ${(props) => (props.disabled ? "#cccccc" : "#7CA83A")};
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const RowButton = styled.button`
  background: ${azul};
  border: 1px solid ${gris};
  border-radius: 5px;
  padding: 4px 8px;
  color: white;
`;

export const TabContent = styled.div`
  margin-top: -5px;
  animation: ${fadeIn} 0.5s ease-in-out;
  background-color: #fff;
  z-index: 0;
  padding: 10px;
  border-radius: 10px;
  position: relative;
  z-index: 2;
  width: 100%;
`;

export const Tab = styled.div`
  margin-top: 20px;
  width: auto;
  justify-content: start;
  padding: 10px 20px;
  background-color: ${({ active }) => (active ? azul : gris)};
  position: relative;
  z-index: ${({ active }) => (active ? 3 : 2)};
  color: #fff;
  border-radius: 5px;
  display: inline-block;
  cursor: pointer;
  user-select: none;

  @media screen and (max-width: 800px) {
    padding: 10px 10px;
  }
`;

export const CustomDialog = styled.dialog`
  border: 1px solid ${gris};
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
`;
